import { Controller } from "@hotwired/stimulus"

// ページネーション付きチェックボックスの選択状態をページ間で保持する
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "store", "count"]
  static values = { fieldName: String }

  connect() {
    this.syncCheckboxes()
    this.syncSelectAll()
    this.updateCount()
  }

  toggle() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => {
      cb.checked = checked
      this.updateStore(cb.value, checked)
    })
    this.updateCount()
  }

  change(event) {
    const cb = event.target
    this.updateStore(cb.value, cb.checked)
    this.syncSelectAll()
    this.updateCount()
  }

  updateStore(id, checked) {
    const existing = this.storeTarget.querySelector(`input[value="${id}"]`)
    if (checked && !existing) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = this.fieldNameValue
      input.value = id
      this.storeTarget.appendChild(input)
    } else if (!checked && existing) {
      existing.remove()
    }
  }

  syncCheckboxes() {
    const selectedIds = new Set(
      Array.from(this.storeTarget.querySelectorAll("input")).map(i => i.value)
    )
    this.checkboxTargets.forEach(cb => {
      cb.checked = selectedIds.has(cb.value)
    })
  }

  syncSelectAll() {
    if (!this.hasSelectAllTarget) return
    const all = this.checkboxTargets
    this.selectAllTarget.checked = all.length > 0 && all.every(cb => cb.checked)
  }

  updateCount() {
    if (!this.hasCountTarget) return
    const count = this.storeTarget.querySelectorAll("input").length
    this.countTarget.textContent = count > 0 ? `(${count}名選択中)` : ""
  }
}
